import React, { Component } from 'react';
//import './ScreenInvaders.css';

import './ScreenAbout.css';

class BlockAbout extends Component
{
  render()
  {
      return (
        <div className="index-block bg-white" id="BlockAbout">
          <div className="container">
            <div className="row main">
              <div className="col-xs-12 col-md-2"></div>
              <div className="col-xs-12 col-md-8">
                <h3>About us</h3>
                <hr />
                <div className="description">
                  <p>We are a team of brains focused on creating highly interactive user experiences in the digital reality. Constantly filtering new technologies, we always pick the most compelling way to tell your story to clients.</p>
                  <p>If you represent a creative part of your industry and you are looking for support, consulting or implementation of your product, or you just feel you need a bit of inspiration for you next groundbreaking idea - give us a shout.</p>
                  <p><strong>Big ideas and brave challenges are most welcome here.</strong></p>
                </div>
              </div>
              <div className="col-xs-12 col-md-2"></div>
            </div>
          </div>
        </div>
      )
  }
}

export default BlockAbout;



// WEBPACK FOOTER //
// ./src/screens/screenAbout/BlockAbout.js